// extracted by mini-css-extract-plugin
export var skipAnimation = "_4k-0";